export const alternativeCodeLabel = "Cód. Alternativo";
export const resourceGroupLabel = "Grupo do Insumo";



// WEBPACK FOOTER //
// ./src/common/constants/index.ts